import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeneralService } from '../general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-claims-form',
  templateUrl: './claims-form.component.html',
  styleUrls: ['./claims-form.component.css'],
})
export class ClaimsFormComponent {
    readonly dialoRef = inject(MatDialogRef<ClaimsFormComponent>);

  data = inject(MAT_DIALOG_DATA);
  // value = ''

  file: any;
  file2: any;
  claimsForm!: FormGroup;
  fileName = '';
  fileName2 = '';

  constructor(
    private fb: FormBuilder, 
    private s: GeneralService,
    private toast: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.claimsForm = this.fb.group({
      incident_location: [''],
      incident_date: [''],
      claim_amount: [''],
      incident_description: [''],
    });

    this.cdr.detectChanges()
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    this.fileName = this.file.name;
  }

  onFileChange2(event: any) {
    this.file2 = event.target.files[0];
    this.fileName2 = this.file2.name;
  }

  submit() {
    let formData = new FormData();
    formData.append('report_upload', this.file);
    formData.append('upload', this.file2);
    formData.append('incident_location', this.claimsForm.controls['incident_location'].value!);
    formData.append('incident_date', this.claimsForm.controls['incident_date'].value!);
    formData.append('claim_amount', this.claimsForm.controls['claim_amount'].value!);
    formData.append('incident_description', this.claimsForm.controls['incident_description'].value!);
    formData.append('destination', this.data['destination']),
    formData.append('packageName', this.data['packageName']),
    formData.append('gross_premium', this.data['gross_premium']),
    formData.append('number_of_days', this.data['number_of_days']),
    formData.append('payment_plan', this.data['payment_plan']),
    formData.append('email', this.data['email']),
    formData.append('startDate', this.data['startDate']),
    formData.append('endDate', this.data['endDate']),
    formData.append('policy_number', this.data['policy_number']),
    formData.append('policy_detail_id', this.data['policy_detail_id']),

    this.s.createClaim(formData).subscribe((res: any) => {
      console.log(res)
      this.toast.success("You've Successfully Logged a Claim, check Claim History to track your claims.", "Claim Submitted");
      this.s.loader = false;
      this.dialoRef.close()
    })
  }
}
